export const POSITION_OPTIONS = {
  TOP: "top",
  BOTTOM: "bottom",
  NONE: "none",
};
